import { useQuery } from '@tanstack/react-query';

import { myActiveMembersKey, requestMyActiveMembers } from './membersApi';

/**
 * The rows of the directory's All Active Members view, at the app's default staleness.
 *
 * No `Failure` variant to handle: `myActiveMembers` is a pure read, so infrastructure errors travel
 * the standard GraphQL errors envelope, and the directory shows them as its error state.
 */
export function useMyActiveMembers() {
  return useQuery({ queryKey: myActiveMembersKey, queryFn: requestMyActiveMembers });
}
